module.exports = __webpack_public_path__ + "img/bg-1.8f0d9a2a.jpg";